import { Marina } from 'src/app/models';
import { MovementLocationSubType } from '../enums/movements/movement-location-sub-type';
import { MovementLocationType } from '../enums/movements/movement-location-type';

export class MovementLocation {
  id: number;
  name?: string;
  abbreviation?: string;
  type?: MovementLocationType;
  subTypeSet?: MovementLocationSubType;
  capacity?: number;
  marina?: Marina;
  active?: boolean = true;
  vacancyControl?: boolean;
  createdAt?: any;
  updatedAt?: any;
  prefixUse?:boolean;
}
